/**
 * Mega-Menü Regal-Karten (snippets/mega-shelf.liquid, mega_menu_style: shelf).
 *
 * - Drag-to-scroll mit der Maus (Touch nutzt nativen Momentum-Scroll).
 * - Scroll-Indicator: zentrierte Pille mit Daumen, zeigt die Position und
 *   lässt sich ziehen bzw. anklicken (Click-to-jump).
 * - Weiche Edge-Fades: Zustandsklassen is-overflow-start / is-overflow-end,
 *   damit links/rechts nichts hart abgeschnitten wirkt.
 *
 * Funktioniert auch, wenn die Reihe erst später sichtbar wird (Mobile-Akkordeon),
 * dank ResizeObserver.
 */
(function () {
  'use strict';

  var INIT = '__mkMegaShelf';
  var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };

  function clamp(v, min, max) { return v < min ? min : (v > max ? max : v); }

  function setup(shelf) {
    if (shelf[INIT]) return;
    var row = shelf.querySelector('[data-mm-shelf-row]');
    if (!row) return;
    shelf[INIT] = true;

    var track = shelf.querySelector('[data-mm-shelf-bar]');
    var thumb = shelf.querySelector('[data-mm-shelf-progress]');
    var ticking = false;

    function paint() {
      ticking = false;
      var scrollable = row.scrollWidth - row.clientWidth;

      if (scrollable <= 1) {
        shelf.classList.remove('mm-shelf--scrollable', 'is-overflow-start', 'is-overflow-end');
        if (thumb) thumb.style.width = '0px';
        return;
      }

      shelf.classList.add('mm-shelf--scrollable');
      var x = row.scrollLeft;
      shelf.classList.toggle('is-overflow-start', x > 2);
      shelf.classList.toggle('is-overflow-end', x < scrollable - 2);

      if (thumb && track) {
        var view = row.clientWidth / row.scrollWidth;
        var trackW = track.clientWidth;
        var thumbW = Math.max(28, view * trackW);
        var travel = trackW - thumbW;
        var ratio = x / scrollable;
        thumb.style.width = thumbW + 'px';
        thumb.style.transform = 'translateY(-50%) translateX(' + (travel * ratio) + 'px)';
      }
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      raf(paint);
    }

    row.addEventListener('scroll', schedule, { passive: true });

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(schedule).observe(row);
    } else {
      window.addEventListener('resize', schedule);
    }

    // Browser-eigenen Link-/Bild-Drag unterbinden (sonst kein Scroll-Drag).
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // --- Maus-Drag auf der Kartenreihe. Touch bleibt nativer Scroll. ---
    var down = false;
    var moved = false;
    var startX = 0;
    var startLeft = 0;

    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (e.button != null && e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startLeft = row.scrollLeft;
      row.classList.add('is-grabbing');
    });

    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 3) moved = true;
      if (moved) {
        row.scrollLeft = startLeft - dx;
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });

    function release() {
      if (!down) return;
      down = false;
      row.classList.remove('is-grabbing');
    }
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);

    // Nach einem Drag den Klick auf die Karte unterdrücken.
    row.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    // --- Scroll-Indicator: ziehen + Click-to-jump ---
    if (track) {
      var barRect = null;

      function jumpTo(clientX) {
        var trackW = track.clientWidth;
        var view = row.clientWidth / row.scrollWidth;
        var thumbW = Math.max(28, view * trackW);
        var maxTravel = trackW - thumbW;
        var pos = clientX - barRect.left - thumbW / 2;
        var ratio = maxTravel > 0 ? clamp(pos / maxTravel, 0, 1) : 0;
        row.scrollLeft = ratio * (row.scrollWidth - row.clientWidth);
      }

      var dragging = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.button != null && e.button !== 0) return;
        if (row.scrollWidth - row.clientWidth <= 1) return;
        dragging = true;
        barRect = track.getBoundingClientRect();
        track.classList.add('is-dragging');
        if (track.setPointerCapture) {
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
        jumpTo(e.clientX);
        e.preventDefault();
      });

      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        jumpTo(e.clientX);
        e.preventDefault();
      });

      function barRelease() {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
      }
      track.addEventListener('pointerup', barRelease);
      track.addEventListener('pointercancel', barRelease);
    }

    schedule();
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var shelves = scope.querySelectorAll('[data-mm-shelf]');
    for (var i = 0; i < shelves.length; i++) setup(shelves[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme-Editor: Header-Section neu geladen.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
